<script setup>
/**
 * Flex spacer that grows to fill available space; the standard way to push toolbar actions right.
 *
 * @status recommended
 * @group layout
 * @useWhen Pushing toolbar actions or other flex children to the opposite end of a row
 */
defineOptions({ name: 'HrSpace' });
</script>

<template>
  <div
    v-bind="$attrs"
    class="hr-space"
  />
</template>

<style scoped>
.hr-space {
  flex: 1 1 auto;
}
</style>
